import React from 'react'
import CloseIcon from '@mui/icons-material/Close'
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Stack,
  Typography
} from '@mui/material'
import { format } from 'date-fns'
import { PropsListCtaCte } from './TableCtaCte'

// Une header + valor para cada item, en el mismo orden que las columnas de la tabla original
const buildFields = (item: any, headers?: string[]) => {
  const formatDate = format(new Date(item.fechaFormateada), 'dd/MM/yyyy HH:mm:ss')
  const values = [
    item.idContrato,
    item.idContratoCuentaCorriente,
    formatDate,
    item.productoNombre,
    item.movimientoTipo + ' ' + item.movimiento,
    item.medioDePago,
    item.comisionMedioDePago,
    item.observaciones != null ? item.observaciones : '-'
  ]

  return values.map((value, index) => ({
    label: headers?.[index] ?? '',
    value
  }))
}

// Arreglar diseño cards
const CardsCtaCte: React.FC<PropsListCtaCte> = (props: PropsListCtaCte) => {
  return (
    <Dialog
      open={props?.show}
      onClose={props?.closeRenovations}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        sx: {
          width: '100%',
          marginLeft: '-20rem'
        }
      }}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        Movimientos
        <IconButton onClick={props?.closeRenovations} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Stack spacing={2}>
          {props.result.map((item: any) => {
            const fecha = new Date(item.fechaFormateada)
            const formatDate = format(fecha, 'dd/MM/yyyy HH:mm:ss')
            return (
              <Card key={item.idContratoCuentaCorriente} variant="outlined" sx={{ borderRadius: 2 }}>
                <CardContent sx={{ p: 2.5 }}>
                  {item.idContrato && (
                    <Typography sx={{ fontSize: '1rem', mb: 0.5 }}>
                      <strong>ID Contrato:</strong> {item.idContrato}
                    </Typography>
                  )}
                  {item.idContratoCuentaCorriente && (
                    <Typography sx={{ fontSize: '1rem', mb: 0.5 }}>
                      <strong>ID Cta Cte:</strong> {item.idContratoCuentaCorriente}
                    </Typography>
                  )}
                  {formatDate && (
                    <Typography sx={{ fontSize: '1rem', mb: 0.5 }}>
                      <strong>Fecha:</strong> {formatDate}
                    </Typography>
                  )}
                  {item.productoNombre && (
                    <Typography sx={{ fontSize: '1rem', mb: 0.5 }}>
                      <strong>Producto:</strong> {item.productoNombre}
                    </Typography>
                  )}
                  {item.movimientoTipo && (
                    <Typography sx={{ fontSize: '1rem', mb: 0.5 }}>
                      <strong>Movimiento:</strong> {item.movimientoTipo} {item.movimiento}
                    </Typography>
                  )}
                  {item.medioDePago && (
                    <Typography sx={{ fontSize: '1rem', mb: 0.5 }}>
                      <strong>Medio de pago: </strong>
                      {item.medioDePago}
                    </Typography>
                  )}
                  {item.comisionMedioDePago != null && (
                    <Typography sx={{ fontSize: '1rem', mb: 0.5 }}>
                      <strong>Comisión:</strong> {item.comisionMedioDePago}
                    </Typography>
                  )}
                  {item.observaciones && (
                    <Typography sx={{ fontSize: '1rem', mb: 0.5 }}>
                      <strong>Observaciones:</strong> {item.observaciones}
                    </Typography>
                  )}
                  <Divider sx={{ my: 1 }} />
                  <Box sx={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>
                    <Button
                      variant="contained"
                      color="success"
                      size="small"
                      sx={{ width: '100%' }}
                      onClick={() => {
                        props.setEditMovimiento(item)
                        props.setEdit(true)
                      }}
                    >
                      Editar
                    </Button>
                    <Button
                      variant="contained"
                      color="error"
                      size="small"
                      sx={{ width: '100%' }}
                      onClick={() => {
                        props.onDelete(item.idContratoCuentaCorriente, item.idClienteLocal)
                      }}
                    >
                      Borrar
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            )
          })}
        </Stack>
      </DialogContent>
    </Dialog>
  )
}

export default CardsCtaCte
